import { format, isSameDay, isSameYear } from 'date-fns';
import React, { forwardRef } from 'react';
import {
  ReactionSelector,
  ReactionSelectorProps,
  ReactionsList,
} from 'stream-chat-react';

export const reactionList = [
  'fire',
  'muscle',
  'cold_sweat',
  'punch',
  'tada',
  'heart',
];

export const reactionOptions = reactionList.map((x, i) => ({
  id: x,
  name: '' + (i + 1) + x,
  spriteUrl:
    'https://unpkg.com/emoji-datasource-twitter@4.0.4/img/twitter/sheets-256/64.png',
  sheetSize: 64,
  sheetColumns: 52,
  sheetRows: 52,
  custom: true,
  emoticons: [],
  short_names: [],
}));

export const CustomReactionsList = forwardRef((rest, ref) => (
  <ReactionsList {...{ reactionOptions }} {...{ ref }} {...rest} />
));

export const CustomReactionSelector = forwardRef(
  (
    rest: ReactionSelectorProps,
    ref: React.ForwardedRef<HTMLDivElement | null>,
  ) => <ReactionSelector {...{ reactionOptions, ref }} {...rest} />,
);

export const chatFormatDate = (date: Date) => {
  const now = Date.now();
  return isSameDay(now, date)
    ? format(date, 'h:mmaa')
    : isSameYear(now, date)
    ? format(date, 'MMM d')
    : format(date, 'MMM d, yyyy');
};
